/* eslint-disable @typescript-eslint/no-explicit-any */
import '@vaadin/multi-select-combo-box';

import { Component, css, html, LitElement, property } from '@rxdi/lit-html';
import { Renderer } from '@shared/directives';

import { comboBoxRenderer } from './multi-select-renderer.directive';

/**
 * @customElement multi-select-box
 */
@Component({
  selector: 'multi-select-box',
  styles: [
    css`
      vaadin-multi-select-combo-box {
        width: 100%;
      }
    `,
  ],
  template(this: MultiSelectComponent) {
    return html`
      <vaadin-multi-select-combo-box
        name=${this.name}
        label=${this.label}
        .itemLabelPath=${this.itemLabelPath}
        .itemIdPath=${this.itemIdPath}
        @selected-items-changed=${this.selectedItemsChanged}
        .selectedItems=${this.selectedItems}
        .items=${this.items}
        ${comboBoxRenderer(this.template)}
      >
      </vaadin-multi-select-combo-box>
    `;
  },
})
export class MultiSelectComponent extends LitElement {
  @property({
    type: Array,
  })
  items: any[];

  @property({
    type: String,
  })
  itemLabelPath: string;

  @property({
    type: String,
  })
  itemIdPath: string;

  @property({
    type: String,
  })
  label: string;

  @property({
    type: String,
  })
  name: string;

  @property({
    type: Array,
  })
  selectedItems: any[];

  @property()
  template: Renderer;

  private selectedItemsChanged(e: CustomEvent) {
    this.dispatchEvent(new CustomEvent('selectedItemsChanged', { detail: e.detail }));
  }
}
